<template>
  <div class="main-header">
    <div class="header-top">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-sm-8 left">
            <ul class="icon-ul">
              <li>
                <img
                  src="@/assets/img/icon01.png"
                  alt="email"
                  title="email"
                /><span>info@fawcamionmexico.com</span>
              </li>
              <li>
                <img
                  src="@/assets/img/icon04.png"
                  alt="mobile phone"
                  title="mobile phone"
                /><span>5955961886</span>
              </li>
              <li>
                <img
                  src="@/assets/img/icon03.png"
                  alt="WhatsApp"
                  title="WhatsApp"
                /><span>5951226144</span>
              </li>
            </ul>
          </div>
          <div class="col-xs-12 col-sm-4 right">
            <ul class="right-ul">
              <li><router-link to="/login" v-if="!token">Sign in</router-link></li>
              <li><router-link to="/register" v-if="!token">Register</router-link></li>
            </ul>
            <el-dropdown @command="handleCommand" v-if="token||userInfo!==null">
              <span class="el-dropdown-link">
                {{ userInfo.username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">修改密码</el-dropdown-item>
                <el-dropdown-item command="2" divided
                  >退出登录</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="navigation">
      <div class="container">
        <div class="row">
          <div class="col-xs-3 col-sm-3">
            <router-link to="/" class="logo">
              <img src="@/assets/img/logo04.png" alt="" class="logo-img" />
            </router-link>
          </div>
          <div class="col-xs-9 col-sm-9">
            <ul class="main-navbar">
              <li
                class="nav-li"
                :class="{ active: item.path == route.path }"
                v-for="item in navList"
                :key="item.path"
              >
                <router-link
                  :to="item.path"
                  :key="item.path"
                  class="nav-link"
                  v-if="item.meta"
                >
                  <span>{{ item.meta.title }}</span>
                </router-link>
              </li>
              <!-- <li class="nav-li active">
								<a href="#" class="nav-link" target="_blank"> 一级</a>
									<ul class="nav-erji">
										<li class="nav-erji-li">
											<a href="{$t2.url}" class="nav-erji-link" title="{$t2.name}">
												耳机
											</a>
										</li>
									</ul>
							</li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  data() {
    return {
			token: localStorage.getItem('token'),
			userInfo: JSON.parse(localStorage.getItem('userInfo')),
      route: null,
      navList: null,
    };
  },
  created() {
		console.log(this.userInfo)
		if(this.userInfo==null){
			localStorage.clear()
		}
    this.route = this.$route;
    this.navList = this.$router.options.routes[0].children;
  },
  mounted() {
    new WOW().init();
  },
  watch: {
    $route() {
      this.route = this.$route;
      this.navList = this.$router.options.routes[0].children;
      new WOW().init();
    },
  },
  methods: {
    handleCommand(command) {
      if (command == "1") {
        this.$router.push("/passwordChange");
      } else if (command == "2") {
				localStorage.clear()
        this.$router.push("/login");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// 统一头部
.main-header {
  .header-top {
    background-color: #000000;
    color: #cccccc;
    padding: 8px 0;
    min-width: max-content;

    .icon-ul {
      li {
        float: left;
        padding: 0 15px;
        border-left: 1px solid #cccccc;

        &:first-child {
          padding: 0 15px 0 0;
          border-left: none;
        }

        img {
          margin: 0 5px 0 0;
        }
      }
    }

    .left {
    }

    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .right-ul {
        float: right;
        margin: 3px 0 0 0;
        li {
          float: left;
          padding: 0 0 0 30px;
          color: #cccccc;
          a {
            color: #cccccc;
          }
        }
      }
      .el-dropdown {
        margin: 0 0 0 30px;
        span {
          color: #cccccc;
        }
      }
    }
  }

  .navigation {
    .logo {
      .logo-img {
				max-width:90%;
        margin: 22px 0 0 0;
      }
    }

    .main-navbar {
      text-transform: uppercase;
      float: right;
      font-size: 16px;
      color: #333;

      .nav-li {
        float: left;
        position: relative;

        .nav-link {
          padding: 30px 30px;
          height: 88px;
          box-sizing: border-box;
          span {
            padding: 0 0 3px 0;
          }
        }

        a {
          display: block;
        }

        &.active {
          .nav-link {
            span {
              border-bottom: 4px solid $main-color;
              color: $main-color;
              font-weight: bold;
            }
          }
        }

        &:hover {
          .nav-link {
            span {
              border-bottom: 4px solid $main-color;
              color: $main-color;
              font-weight: bold;
            }
          }

          .nav-erji {
            display: block;
          }
        }

        .nav-erji {
          display: none;
          position: absolute;
          z-index: 1000;
          top: 88px;
          left: 0px;
          border-radius: 5px;
          background-color: #fff;
          border: 1px solid #eee;
          box-shadow: 5px 5px rgba(85, 97, 111, 0.2);

          .nav-erji-li {
            white-space: nowrap;

            .nav-erji-link {
              padding: 10px 20px;
              color: #333;
            }

            &:hover {
              .nav-erji-link {
                color: $main-color;
                background-color: #f5f5f5;
              }
            }

            &.active {
              .nav-erji-link {
                color: $main-color;
                background-color: #f5f5f5;
              }
            }

            .nav-sanji {
              .nav-sanji-li {
                white-space: nowrap;

                .nav-sanji-link {
                  padding: 10px 20px;
                  color: #333;
                  background-color: #fff;
                }

                &:hover {
                  .nav-sanji-link {
                    color: $main-color;
                  }
                }

                &.active {
                  .nav-sanji-link {
                    color: $main-color;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .mobile-navigation {
    padding: 0;
    position: relative;

    .navigation-top {
      overflow: hidden;
      background-color: #fff;
      padding: 15px;
      height: 70px;
      box-sizing: border-box;

      .logo {
        float: left;
        width: 50%;
        max-width: 244px;
      }

      .switch-icon {
        float: right;
        border: 1px solid $main-color;
        border-radius: 4px;
        padding: 7px 7px 2px 7px;
        cursor: pointer;

        .line {
          width: 26px;
          height: 3px;
          background-color: $main-color;
          margin: 0 0 5px;
        }
      }
    }

    .main-navbar {
      display: none;
      z-index: 1000;
      background-color: #f4f6fa;
      position: absolute;
      left: 0;
      right: 0;
      top: 70px;
      font-size: 16px;

      .nav-li {
        margin: 0 0 0 20px;
        position: relative;

        .nav-link {
          padding: 6px 20px 6px 0px;
          border-bottom: 1px solid #e5e5e5;
          height: 40px;
        }

        .iconfont {
          position: absolute;
          top: 0px;
          right: 0px;
          width: 48px;
          height: 40px;
          line-height: 40px;
          border: 1px solid #e5e5e5;
          text-align: center;
          float: right;
          cursor: pointer;
        }

        a {
          display: block;
        }

        &.active {
          .nav-link {
            color: $main-color;
            font-weight: bold;
          }
        }

        .nav-erji {
          display: none;

          .nav-erji-li {
            margin: 0 0 0 20px;
            border-bottom: 1px solid #e5e5e5;
            padding: 6px 20px 6px 0;

            &.active {
              .nav-erji-link {
                color: $main-color !important;
                font-weight: bold;
              }
            }

            .nav-erji-link {
            }
          }
        }
      }
    }
  }
}
</style>
